import { css } from '@emotion/react';
import { ReactNode } from 'react';
import { theme } from 'styles/theme';

export const Badge = ({
	success,
	secondary,
	primary,
	primaryFill,
	grayFill,
	children,
	small,
}: {
	success?: boolean;
	primary?: boolean;
	secondary?: boolean;
	primaryFill?: boolean;
	grayFill?: boolean;
	small?: boolean;
	children?: ReactNode;
}) => {
	return (
		<div
			css={css`
				background: #f0f1f4;
				color: ${theme.color.text[300]};
				font-size: 12px;
				line-height: 20px;
				padding: 0 12px;
				border-radius: 12px;
				display: inline-block;

				text-align: center;

				${small &&
				css`
					font-size: 11px;
					height: 16px;
					line-height: 16px;
					padding: 0 8px;
					font-weight: bold;
					min-width: 24px;
				`};

				${primary &&
				css`
					background: #f0f1ff;
					color: ${theme.color.primary[400]};
				`}

				${secondary &&
				css`
					background: #fff6e5;
					color: #cc8400;
				`}

				${success &&
				css`
					background: #e3f7ea;
					color: #2d9f53;
				`}

				${primaryFill &&
				css`
					background: ${theme.color.primary[400]};
					color: #fff;
				`}

				${grayFill &&
				css`
					background: #8c8ea6;
					color: #fff;
				`}
			`}
		>
			{children}
		</div>
	);
};
